module.exports = __webpack_public_path__ + "static/steel_predator-f4b50e8fe969339cecd8796ac95a319c.png";